// TODO: IE対応が楽になったので不要なら削除する
// ポリフィル
import polyfill from './inc/polyfill.js';
polyfill();

// ブラウザやデバイスなどの環境を判定（IEを判定してbodyタグにclass付与）
import { EnvDetector } from './inc/EnvDetector.js';
new EnvDetector();

// スクロール時にhoverを無効化してパフォーマンスを向上させる
import { ScrollPerformanceOptimizer } from './inc/ScrollPerformanceOptimizer.js';
new ScrollPerformanceOptimizer();

// will-changeを最適化したい場合は以下コードをコメントアウト
// transformやopacityには使わず、box-shadowなどパフォーマンスに影響するプロパティにのみ使用する
// import { WillChangeOptimizer } from './inc/WillChangeOptimizer.js';
// const configs = [
//   { parentSelector: '.wrapper_area1', targetSelector: '.target1', property: 'opacity' },
//   { parentSelector: '.wrapper_area2', targetSelector: '.target2', property: 'transform' },
//   // 他の設定を追加することも可能です
// ];

// configs.forEach(config => {
//   new WillChangeOptimizer(config.parentSelector, config.targetSelector, config.property);
// });


// ローディング画面の管理
import { LoadingScreenManager } from './inc/LoadingScreenManager.js';
new LoadingScreenManager({
  logoFadeInDuration: '1s',
  developmentMode: false
});

// スクロール状態の管理
import { ScrollStateManager } from './inc/ScrollStateManager.js';
new ScrollStateManager();

// Scroll Magicによるスクロール管理
// import { ScrollManager } from './inc/ScrollManager.js';
// new ScrollManager();

import { Observable } from './inc/Observable.js';
import { ScrollFire } from './inc/ScrollFire.js';

const navLinks = document.querySelectorAll('#site-navigation a');
const currentSection = new Observable(null);
const beforeSection = new Observable(null);

currentSection.subscribe((newSection, oldSection) => {
  console.log(newSection, oldSection);
  beforeSection.value = oldSection;
  navLinks.forEach((navLink) => {
    if (newSection === '#main-visual' || navLink.hash === newSection) {
      navLink.classList.add('is-active');
    } else {
      navLink.classList.remove('is-active');
    }
  });
});

// rootMarginに画面の半分の値を入れる（デフォルトは'0px'）
const rootMargin = Math.floor(-(window.innerHeight / 4)) + 'px';

new ScrollFire({
  targetSelector: '[data-scroll]',
  className: 'in-view',
  rootMargin,
  threshold: [0],
  onEnter: (element) => {
    currentSection.value = '#' + element.id;
  },
  onExit: (element) => {
    if (currentSection.value === '#' + element.id) {
      currentSection.value = beforeSection.value;
    }
  },
});

// Scroll Top
import { ScrollTop } from './inc/ScrollTop.js';
new ScrollTop({
  scrollThreshold: 100,
});

// Swiperによるスライダー管理
import { SliderManager } from './inc/SliderManager.js';
new SliderManager();

// CSSのカスタムプロパティを管理
import { CustomPropertyManager } from './inc/CustomPropertyManager.js';
new CustomPropertyManager();

// メニュー管理（ハンバーガーメニュー、モーダル）
import { MenuManager } from './inc/MenuManager.js';
new MenuManager();

// 要素をスクロール時に隠す
import { hideOnScroll } from './inc/HideOnScroll.js';
new hideOnScroll();

import { TabManager } from './inc/TabManager.js';
new TabManager();

import { Accordion } from './inc/Accordion.js';
document.querySelectorAll('.c-accordion').forEach((el) => {
  new Accordion(el, el.classList.contains('is-open') ? true : false);
});

import { VideoManager } from './inc/VideoManager.js';
new VideoManager();

import { ContentFilter } from './inc/ContentFilter.js';
new ContentFilter({
  activeClass: 'is-active',
  fadeInClass: 'is-fade-in',
});

import { YouTubePlayer } from './inc/YouTubePlayer.js';
import { Modal } from './inc/Modal.js';
new Modal({
  modalClass: '.c-modal',
  onInit: (modalElement) => {
    if (!modalElement.classList.contains('c-modal--video')) return;
    const videoContainerSelector = '.yt-video-container';
    const videoContainer = modalElement.querySelector(videoContainerSelector);
    const id = videoContainer.getAttribute('id');
    const videoId = videoContainer.getAttribute('data-video-id');
    modalElement.ytPlayer = new YouTubePlayer(`#${id}`, videoId);
  },
  onShow: (modalElement) => {
    if (!modalElement.classList.contains('c-modal--video')) return;
    /**
     * YT.PlayerState.ENDED: 0
     * YT.PlayerState.PLAYING: 1
     * YT.PlayerState.PAUSED: 2
     * YT.PlayerState.BUFFERING: 3
     * YT.PlayerState.CUED: 5
     */

    // ポーズ中(再生して一度停止)なら再生する
    if (modalElement.ytPlayer.player.getPlayerState() === 2) {
      modalElement.ytPlayer.play();
    }
  },
  onHide: (modalElement) => {
    if (!modalElement.classList.contains('c-modal--video')) return;
    modalElement.ytPlayer.pause();
  }
});

// 開発用の機能郡（本番公開時に削除する）
// import { DevUtils } from './inc/DevUtils.js';
// new DevUtils();

// ページごとの機能
import { HomePage } from '@pages/HomePage';
document.addEventListener('DOMContentLoaded', function () {
  // URLを使用して現在のページを判別
  const url = new URL(window.location.href);
  if (url.pathname !== '/') return;

  new HomePage();
});

// 地域材利用促進部会
import { ResourcesPage } from '@pages/ResourcesPage';
document.addEventListener('DOMContentLoaded', function () {
  // URLを使用して現在のページを判別
  const url = new URL(window.location.href);

  // TODO: パーマリンク修正するまで以下コメントアウト
  // if (url.pathname !== '/resources/') return;
  if (url.pathname !== '/') return;

  // p-page-contentのウィンドウ上部からの距離を取得し、rootにカスタムプロパティを設定
  const pageContent = document.querySelector('.p-page-content');
  const pageContentRect = pageContent.getBoundingClientRect();
  const pageContentTop = Math.ceil(pageContentRect.top + window.scrollY);
  document.documentElement.style.setProperty('--page-content-scroll-y', pageContentTop + 'px');

  // resize イベントを監視
  window.addEventListener('resize', function () {
    const pageContentRect = pageContent.getBoundingClientRect();
    const pageContentTop = Math.ceil(pageContentRect.top + window.scrollY);
    document.documentElement.style.setProperty('--page-content-scroll-y', pageContentTop + 'px');
  });

  // ダウンロード追加で見るボタン
  new ResourcesPage();
});
